'use client';

import React, { useRef } from 'react';
import CategoryIcon from '@/components/ui/CategoryIcon';

interface Category {
  key: string;
  label: string;
}

const categories: Category[] = [
  { key: 'all',          label: 'All' },
  { key: 'action',       label: 'Action' },
  { key: 'anime',        label: 'Anime' },
  { key: 'movies',       label: 'Movies' },
  { key: 'tvshows',      label: 'TV Shows' },
  { key: 'gaming',       label: 'Gaming' },
  { key: 'celebrities',  label: 'Celebrities' },
  { key: 'trailers',     label: 'Trailers' },
  { key: 'horror',       label: 'Horror' },
  { key: 'scifi',        label: 'Sci-Fi' },
  { key: 'comedy',       label: 'Comedy' },
  { key: 'drama',        label: 'Drama' },
  { key: 'documentary',  label: 'Documentary' },
  { key: 'kpop',         label: 'K-Pop' },
  { key: 'edits',        label: 'Edits' },
  { key: 'cars',         label: 'Cars' },
  { key: 'nature',       label: 'Nature' },
  { key: 'sports',       label: 'Sports' },
  { key: 'music',        label: 'Music Videos' },
  { key: 'memes',        label: 'Memes' },
  { key: 'cinematic',    label: 'Cinematic' },
  { key: 'vfx',          label: 'VFX' },
];

interface CategoryBarProps {
  active: string;
  onSelect: (key: string) => void;
}

export default function CategoryBar({ active, onSelect }: CategoryBarProps) {
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={scrollRef}
      className="flex items-center gap-2 overflow-x-auto pb-1"
      style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
    >
      {categories.map((cat) => (
        <button
          key={`cat-${cat.key}`}
          onClick={() => onSelect(cat.key)}
          className={`category-chip flex items-center gap-1.5 ${active === cat.key ? 'category-chip-active' : ''}`}
        >
          <CategoryIcon category={cat.key} size={14} />
          {cat.label}
        </button>
      ))}
    </div>
  );
}